(function () {
  'use strict';
  if (window.__d1CartBundlesInitialized) return;
  window.__d1CartBundlesInitialized = true;

  function getRoutes() {
    return window.routes || {};
  }

  function parseCsvValues(csv) {
    return (csv || '')
      .split(',')
      .map(function (s) { return String(s).trim(); })
      .filter(function (s) { return s.length > 0; });
  }

  function parseLineUpdates(csv) {
    var updates = {};
    parseCsvValues(csv).forEach(function (s) {
      var n = parseInt(s, 10);
      if (n > 0) updates[String(n)] = 0;
    });
    return updates;
  }

  function getSections() {
    var sections = ['cart-icon-bubble'];
    if (document.querySelector('cart-drawer')) {
      sections.push('cart-drawer');
    }
    return sections;
  }

  function postCartUpdate(updates) {
    var keys = Object.keys(updates);
    if (!keys.length) return Promise.resolve();

    var url = getRoutes().cart_update_url || '/cart/update';
    if (!url.endsWith('.js')) {
      url = url.replace(/\/?$/, '') + '.js';
    }

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        updates: updates,
        sections: getSections(),
        sections_url: window.location.pathname,
      }),
    }).then(function (r) {
      return r.json();
    });
  }

  function removeKeysSafely(csv) {
    var updates = {};
    parseCsvValues(csv).forEach(function (key) {
      updates[key] = 0;
    });
    return postCartUpdate(updates);
  }

  function removeLine(line) {
    if (!line || line < 1) return Promise.resolve();
    var url = getRoutes().cart_change_url || '/cart/change.js';
    if (!url.endsWith('.js')) {
      url = url.replace(/\/?$/, '') + '.js';
    }
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        line: line,
        quantity: 0,
        sections: getSections(),
        sections_url: window.location.pathname,
      }),
    }).then(function (r) {
      return r.json();
    });
  }

  function removeLinesSafely(csv) {
    var lines = (csv || '')
      .split(',')
      .map(function (s) { return parseInt(String(s).trim(), 10); })
      .filter(function (n) { return n > 0; })
      .sort(function (a, b) { return b - a; });

    if (!lines.length) return Promise.resolve();

    // Remove highest line numbers first to avoid index shifts.
    return lines.reduce(function (p, line) {
      return p.then(function () {
        return removeLine(line);
      });
    }, Promise.resolve());
  }

  function refreshCartUi() {
    var tasks = [];
    var drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems && typeof drawerItems.onCartUpdate === 'function') {
      tasks.push(drawerItems.onCartUpdate());
    }
    var pageCart = document.querySelector('cart-items');
    if (pageCart && typeof pageCart.onCartUpdate === 'function') {
      tasks.push(pageCart.onCartUpdate());
    }
    return Promise.all(tasks);
  }

  function syncCartUiFromState(parsedState) {
    if (!parsedState) return;

    var bubbleContainer = document.getElementById('cart-icon-bubble');
    var bubbleHtml = parsedState.sections && parsedState.sections['cart-icon-bubble'];
    if (bubbleContainer && bubbleHtml) {
      var next = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
      if (next) {
        bubbleContainer.innerHTML = next.innerHTML;
      }
    }

    var drawerSectionHtml = parsedState.sections && parsedState.sections['cart-drawer'];
    if (drawerSectionHtml) {
      var nextDrawer = new DOMParser().parseFromString(drawerSectionHtml, 'text/html').querySelector('#CartDrawer');
      var currentDrawer = document.getElementById('CartDrawer');
      if (nextDrawer && currentDrawer) {
        currentDrawer.innerHTML = nextDrawer.innerHTML;
      }
    }

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.toggle('is-empty', parsedState.item_count === 0);
      var inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.toggle('is-empty', parsedState.item_count === 0);
      var drawerItems = drawer.querySelector('cart-drawer-items');
      if (drawerItems) drawerItems.classList.toggle('is-empty', parsedState.item_count === 0);
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof drawer.close === 'function') {
        overlay.addEventListener('click', drawer.close.bind(drawer));
      }
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'd1-cart-bundles', cartData: parsedState });
    }
  }

  function setRemovingState(trigger, busy) {
    if (!trigger) return;
    var row = trigger.closest('tr') || trigger.closest('.cart-item');
    if (row) {
      row.classList.toggle('d1-cart-removing', !!busy);
    }

    trigger.classList.toggle('is-removing', !!busy);
    if (busy) {
      trigger.setAttribute('aria-busy', 'true');
      if ('disabled' in trigger) trigger.disabled = true;
      if (!trigger.querySelector('.d1-cart-remove-spinner')) {
        var spinner = document.createElement('span');
        spinner.className = 'd1-cart-remove-spinner';
        spinner.setAttribute('aria-hidden', 'true');
        trigger.appendChild(spinner);
      }
    } else {
      var leftover = trigger.querySelector('.d1-cart-remove-spinner');
      if (leftover) leftover.remove();
      trigger.removeAttribute('aria-busy');
      if ('disabled' in trigger) trigger.disabled = false;
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var removeBundle = e.target.closest('[data-d1-bundle-remove-lines]');
      if (removeBundle) {
        e.preventDefault();
        var lines = removeBundle.getAttribute('data-d1-bundle-remove-lines');
        var keys = removeBundle.getAttribute('data-d1-bundle-remove-keys');
        setRemovingState(removeBundle, true);
        (keys ? removeKeysSafely(keys) : removeLinesSafely(lines))
          .then(function (parsedState) {
            syncCartUiFromState(parsedState);
            return refreshCartUi();
          })
          .finally(function () {
            setRemovingState(removeBundle, false);
          });
        return;
      }

      var cascadeHost = e.target.closest('cart-remove-button[data-d1-cascade-remove]');
      if (!cascadeHost) return;
      var removeCtrl = e.target.closest('a, button');
      if (!removeCtrl || !cascadeHost.contains(removeCtrl)) return;

      var raw = cascadeHost.getAttribute('data-d1-cascade-remove');
      if (!raw) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var parts = raw.split('|');
      var parentLine = parts[0];
      var childCsv = parts[1] || '';
      var rawKeys = cascadeHost.getAttribute('data-d1-cascade-remove-keys') || '';
      var keyParts = rawKeys.split('|');
      var parentKey = keyParts[0];
      var childKeysCsv = keyParts[1] || '';

      // Remove children first, then parent (all descending-safe).
      var allLinesCsv = childCsv;
      if (parentLine) {
        allLinesCsv = allLinesCsv ? allLinesCsv + ',' + parentLine : String(parentLine);
      }
      var allKeysCsv = childKeysCsv;
      if (parentKey) {
        allKeysCsv = allKeysCsv ? allKeysCsv + ',' + parentKey : String(parentKey);
      }

      setRemovingState(removeCtrl, true);
      (allKeysCsv ? removeKeysSafely(allKeysCsv) : removeLinesSafely(allLinesCsv))
        .then(function (parsedState) {
          syncCartUiFromState(parsedState);
          return refreshCartUi();
        })
        .finally(function () {
          setRemovingState(removeCtrl, false);
        });
    },
    true
  );
})();
